import React from "react";
import { isBlackFridayActive, BLACK_FRIDAY_SHOP_URL } from "../../config/blackFridayConfig";
import BFBannerBackground from "../../icons/BF2025/BFBannerBackground.svg";
import BFDiscountLabel from "../../icons/BF2025/BFDiscountLabel.svg";
import * as styles from "./BlackFridayBanner.module.scss";
import YellowArrowRight from "../../icons/BF2025/YellowArrowRight.svg";

/**
 * Black Friday promotional banner displayed on all logged-in pages.
 *
 * Shows a full-width banner with promotional messaging and CTA
 * during the Black Friday campaign period (Nov 27 - Dec 2, 2025).
 *
 * @returns {JSX.Element|null} The banner component or null if outside BF period.
 */
const BlackFridayBanner = () => {
	// Only show banner during Black Friday period
	if ( ! isBlackFridayActive() ) {
		return null;
	}

	return (
		<a
			href={ BLACK_FRIDAY_SHOP_URL }
			className={ styles.bannerLink }
			target="_blank"
			rel="noopener noreferrer"
			style={ { backgroundImage: `url(${ BFBannerBackground })` } }
		>

			This Black Friday, you save<span className={ styles.visuallyHidden }>30%</span>
			<img className={ styles.tag } src={ BFDiscountLabel } alt="" />on everything!!
			<span className={ styles.highlight }>Upgrade now<img src={ YellowArrowRight } alt="" /></span>
		</a>
	);
};


export default BlackFridayBanner;
